<template>
  <div class="guide">
    <SubSectionBanner :subSectionData="subSectionData" />
    <section id="servicios" class="secciones seccion-blanca formulario">
      <div class="container">
        <SubSectionStandartHead :subSectionData="subSectionData" />
        <br />
        <br />
        <div class="bloque">
          <div id="accordion" class="acordeon">
            <div class="card card-guide" v-for="(item, index) in item_list" :key="index">
              <div class="card-header" :id="'heading' + index">
                <button
                  :class="
                    (index == 0 && id_guide_url == '') || index == id_guide_url
                      ? 'btn btn-link'
                      : 'btn btn-link collapsed'
                  "
                  data-toggle="collapse"
                  :data-target="'#collapse' + index"
                  aria-expanded="true"
                  :aria-controls="'#collapse' + index"
                >
                  <h5 class="mb-0">{{ item.title_item_es }}</h5>
                  <span class="material-icons">expand_less</span>
                </button>
              </div>

              <div
                :id="'collapse' + index"
                :class="
                  (index == 0 && id_guide_url == '') || index == id_guide_url
                    ? 'collapse show'
                    : 'collapse'
                "
                :aria-labelledby="'#heading' + index"
                data-parent="#accordion"
              >
                <div class="card-body">
                  <span v-html="item.desc_item_es"></span>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
        </div>
      </div>
    </section>
    <GoToTrackingModule />
    <GuideModule />
  </div>
</template>

<style lang="scss">
.guide {
  .card {
    height: auto;
  }
}
.card-guide {
  height: auto;
}

.acordeon .card-header {
  padding: 0;
}
.acordeon .card button.btn.collapsed {
  background-color: rgba(0, 0, 0, 0.03);
  color: rgb(0, 117, 207);
}
.acordeon .card button.btn {
  display: flex;
  align-items: center;
  padding: 15px;
  width: 100%;
  text-align: left;
  color: rgb(255, 255, 255);
  background-color: rgb(0, 117, 207);
}
.acordeon .card button.btn h5 {
  margin-right: auto;
  font-size: 16px;
  text-transform: none;
}
.acordeon .card button.btn:hover,
.acordeon .card button.btn:focus,
.acordeon .card button.btn:active {
  text-decoration: none;
}
.acordeon .card button.btn span {
  webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: all 0.35s;
  -o-transition: all 0.35s;
  transition: all 0.35s;
}
.acordeon .card button.btn.collapsed span {
  webkit-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 0.35s;
  -o-transition: all 0.35s;
  transition: all 0.35s;
}

.form-control {
  border-radius: 0px !important;
  font-size: 13.5px;
}

.contact-inline {
  height: 10px !important;
}
.no-border-country {
  border-radius: 2px !important;
}

.avatar {
  border-radius: 10px;
}
.row-height2 {
  background-color: #e5e5ea;
  border-radius: 15px 15px 15px 15px;
}

.not-padding-left {
  padding-left: 0 !important;
  padding-right: 12px !important;
}
.not-padding-right {
  padding-right: 0 !important;
  padding-left: 12px !important;
}
.posicion-relativa {
  position: relative;
}
.btn-3d-celeste {
  color: rgb(43, 172, 234);
  border-color: rgb(43, 172, 234);
  background-color: transparent;
}
.btn-3d-celeste:hover,
.btn-3d-celeste:focus,
.btn-3d-celeste:active {
  color: rgba(43, 172, 234, 0.7);
}
.btn-3d {
  position: relative;
  display: inline-block;
  top: 0;
  margin-bottom: 0;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  text-transform: uppercase;
  border-style: solid;
  border-top-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 6px;
  border-left-width: 1px;
  border-radius: 8px;
  transition: all 0.15s;
}
.btn-3d:hover {
  top: 4px;
  margin-bottom: 3px;
  border-bottom-width: 3px;
}
.btn-3d:active {
  top: 6px;
  margin-bottom: 5px;
  border-bottom-width: 1px;
}

@media (min-width: 0px) {
  .btn-3d-md {
    padding: 12px;
    font-size: 14px;
  }
  .btn-3d-lg {
    padding: 10px 15px;
    font-size: 14px;
  }
  .not-padding-left-fields {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .not-padding-right-fields {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .not-padding-left-fields-peru {
    padding-left: 0 !important;
    padding-right: 0px !important;
  }
  .not-padding-right-fields-peru {
    padding-right: 0 !important;
    padding-left: 0px !important;
  }
}
@media (min-width: 576px) {
  .btn-3d-md {
    padding: 12px;
    font-size: 14px;
  }
  .btn-3d-lg {
    padding: 10px 15px;
    font-size: 14px;
  }
  .not-padding-left-fields {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .not-padding-right-fields {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .not-padding-left-fields-peru {
    padding-left: 0 !important;
    padding-right: 10px !important;
  }
  .not-padding-right-fields-peru {
    padding-right: 0 !important;
    padding-left: 0px !important;
  }
}
@media (min-width: 768px) {
  .btn-3d-md {
    padding: 12px;
    font-size: 14px;
  }
  .btn-3d-lg {
    padding: 10px 15px;
    font-size: 14px;
  }
  .not-padding-left-fields {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .not-padding-right-fields {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .not-padding-left-fields-peru {
    padding-left: 0 !important;
    padding-right: 12px !important;
  }
  .not-padding-right-fields-peru {
    padding-right: 0 !important;
    padding-left: 12px !important;
  }
}
@media (min-width: 992px) {
  .btn-3d-md {
    padding: 10px 15px;
    font-size: 14px;
  }
  .btn-3d-lg {
    padding: 15px 20px;
    font-size: 15px;
  }
  .not-padding-left-fields {
    padding-left: 0 !important;
    padding-right: 12px !important;
  }
  .not-padding-right-fields {
    padding-right: 0 !important;
    padding-left: 12px !important;
  }
}
@media (min-width: 1200px) {
  .btn-3d-md {
    padding: 15px;
    font-size: 16px;
  }
  .btn-3d-lg {
    padding: 15px 25px;
    font-size: 16px;
  }
  .not-padding-left-fields {
    padding-left: 0 !important;
    padding-right: 12px !important;
  }
  .not-padding-right-fields {
    padding-right: 0 !important;
    padding-left: 12px !important;
  }
}

@import '../assets/css/aa.css';
</style>

<script>
import SubSectionBanner from '@/views/components/SubSectionBanner';
import SubSectionStandartHead from '@/views/components/SubSectionStandartHead';
import GoToTrackingModule from '@/modules/GoToTrackingModule.vue';
import GuideModule from '@/modules/GuideModule.vue';
import axios from 'axios';
import { config_settings } from '@/config.js';

export default {
  components: {
    SubSectionBanner,
    SubSectionStandartHead,
    GoToTrackingModule,
    GuideModule,
  },
  props: ['subSectionData'],
  data() {
    return {
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      cod_sub_sec: this.subSectionData.cod_sub_section,
      item_list: [],
      id_guide_url: this.$route.params.id,
    };
  },
  methods: {
    getItems() {
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/sub_sections/' +
            this.cod_sub_sec +
            '/items_all',
        )
        .then((response) => {
          this.item_list = response.data;
          this.validacion_url();
        })
        .catch((error) => {
          console.log('error');
        });
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    scrollToLink(number) {
      var subir = 800 + number * 30;
      window.scrollTo(0, subir);
    },

    validacion_url() {
      if (this.id_guide_url != '') {
        this.scrollToLink(this.id_guide_url);
      }
    },
  },
  created() {
    this.scrollToTop();
    this.getItems();
  },
};
</script>
